import React from 'react';
import Box from '@mui/material/Box';

import { Spinner } from './Spinner';

export const HomepageFullscreenLoader: React.FC = () => {
  return (
    <Box
      height="100vh"
      width="100%"
      display="flex"
      alignItems="center"
      marginTop={`-var(--Header-Height)`}
    >
      <Spinner size={100} />
    </Box>
  );
};
